// extracted by mini-css-extract-plugin
module.exports = {"commercial":"HomeWidgetCommercial_commercial__civyS","pulse":"HomeWidgetCommercial_pulse__cGP28"};